import { Badge } from 'components/ui/Badge/Badge'
import { Tag, TagsType } from 'services/warehouse-containers/containers/store'

import './tags.style.css'

export interface Props {
  tags: TagsType[]
}

export const Tags = ({ tags }: Props) => {
  const tagList = tags?.map((el, index: number) => {
    switch (el) {
      case Tag.NotFinished:
        return <Badge key={index} text="Не доставлено" />
      case Tag.Pickup:
        return <Badge key={index} text="Сбор" badgeStyle="success"></Badge>
      case Tag.Delivery:
        return <Badge key={index} text="Доставка" badgeStyle="warning"></Badge>
      case Tag.Urgent:
        return <Badge key={index} text="Срочно" badgeStyle="error"></Badge>
      case Tag.VIP:
        return <Badge key={index} text="VIP" badgeStyle="blue" />
      default:
        return null
    }
  })

  return <div className="tags-container">{tagList}</div>
}
